import { storageProvider } from '@ocean/configs'

const SIMULATOR_TRAINING_USER_DECLARATION_VIEWED = 'SIMULATOR_TRAINING_USER_DECLARATION_VIEWED'

// Simulator training user declaration visibility needed for page refresh and direct links
class EndUserDeclarationUtils {
  viewed = 'VIEWED'

  markDeclarationViewed() {
    storageProvider.setItem(SIMULATOR_TRAINING_USER_DECLARATION_VIEWED, this.viewed)
  }

  clearDeclarationViewed() {
    storageProvider.removeItem(SIMULATOR_TRAINING_USER_DECLARATION_VIEWED)
  }

  getDeclarationState() {
    return storageProvider.getItem(SIMULATOR_TRAINING_USER_DECLARATION_VIEWED)
  }
}

export default new EndUserDeclarationUtils()
